<template>
  <el-dialog
    :visible="true"
    :before-close="beforeClose"
    title="气体数据库"
    width="65vw"
    class="materials-database"
    top="10vh"
  >
    <el-tabs v-model="active">
      <el-tab-pane
        v-for="mat in materials"
        :label="mat.type"
        :name="mat.type"
        :key="mat.type"
      ></el-tab-pane>
    </el-tabs>

    <m-table
      :tableData="tableData"
      :tableColumn="tableColumn"
      :indexConfig="tableIndexConfig"
      :hasPagination="false"
    ></m-table>
  </el-dialog>
</template>

<script>
import MTable from '@/components/mTable/m-table.vue';
import { materials } from './data';

export default {
  components: { MTable },
  data() {
    return {
      active: materials[0].type,
      materials,
      tableIndexConfig: {
        enable: true,
        label: '序号',
        width: 100
      },
      tableColumn: [
        { prop: 'name', label: '中文' },
        { prop: 'symbol', label: '代号' }
      ]
    };
  },
  computed: {
    tableData() {
      return materials.find(e => e.type === this.active).list;
    }
  },
  methods: {
    beforeClose(done) {
      this.$destroy();
      done?.();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.materials-database {
  .m-table {
    height: 60vh;

    .el-table {
      height: 100%;

      &__body-wrapper {
        height: calc(100% - 48px);
      }
    }
  }
}
</style>
